var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-1",attrs:{"id":"app-mobil-payment"}},[_c('screen',{attrs:{"use-amount":"","title":_vm.title,"info":_vm.info,"titlesup":_vm.titleSup,"infosup":_vm.infoSup}}),_vm._v(" "),_c('keyboard-code',{attrs:{"value":_vm.data},on:{"input":_vm.input,"del":_vm.del,"cancel":_vm.cancel,"valid":_vm.valid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }